/* eslint-disable */
// automatically generated by the FlatBuffers compiler, do not modify

export enum ReasonCode {
  UNKNOWN = -32768,
  REQUIRED_PERMISSION_MISSING = -32767,
  LIBRARY_LOAD_FAILURE = -32766,
  SYSTEM_SERVICE_UNAVAILABLE = -32765,
  PACKAGE_INFO_MISSING = -32764,
  CONFIGURATION_INVALID = -32763,
  REFLECTION_UNAVAILABLE = -32762,
  REFLECTION_ACCESS_EXCEPTION = -32761,
  INVALID_STATE = -32760,
  JNI_ERROR = -32759,
  THREAD_PANIC = -32758,
  UNMATCHED_SELECTORS = -32757,
  RESPONSE_PARSING_ERROR = -5,
  INVALID_RESPONSE = -4,
  DISABLED = -3,
  OTHER_NETWORK_EXCEPTION = -2,
  IO_EXCEPTION = -1,
}
